import React from 'react'
import PropTypes from 'prop-types'

/* doc
---
title: Card Header Title
name: Card Header Title
category: React - Bulma
parent: Card Header
---

A `CardHeaderTitle` component for adding a title to the `CardHeader`.

See [Bulma Documentation](http://bulma.io/documentation/components/card/) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.

### Props
| Prop Name        | Description                                 |Type            | Default Value             | Required?     |
|------------------|---------------------------------------------|----------------|---------------------------|---------------|
| title            | Text to be added as card title              | string         |                           | no            |


```html_example
  <Card>
    <CardHeader>
      <CardHeaderTitle title="stuff" />
    </CardHeader>
  </Card>
```
*/
function CardHeaderTitle(props) {
  const {
    children, className, title, ...rest
  } = props

  const classes = [
    'card-header-title',
    className || '',
  ]

  return (
    <span {...rest} className={classes.join(' ')}>
      {title || children}
    </span>
  )
}

CardHeaderTitle.propTypes = {
  // Text to display instead of children components.
  title: PropTypes.string,
}

export default CardHeaderTitle
